import { Form, Input, Modal } from '@maxtropy/components';
import { useEffect, useState } from 'react';
import { TopologyAuxiliaryRecord } from './types';

type AuxiliaryDeviceFormValues = Pick<TopologyAuxiliaryRecord, 'name'>;

interface EditAuxiliaryDeviceModalProps {
  open: boolean;
  record?: TopologyAuxiliaryRecord;
  records?: TopologyAuxiliaryRecord[];
  onCancel: () => void;
  onOk: (values: TopologyAuxiliaryRecord) => void;
}

const EditAuxiliaryDeviceModal = (props: EditAuxiliaryDeviceModalProps) => {
  const { open, record, records = [], onCancel, onOk } = props;
  const [form] = Form.useForm<AuxiliaryDeviceFormValues>();
  const [confirmLoading, setConfirmLoading] = useState(false);

  const validateUniqueName = (_: unknown, value?: string) => {
    const name = value?.trim();

    if (!name) {
      return Promise.resolve();
    }

    const existingRecord = records.some(item => item.id !== record?.id && item.name === name);

    if (existingRecord) {
      return Promise.reject(new Error('辅助用能名称已存在'));
    }

    return Promise.resolve();
  };

  useEffect(() => {
    if (!open) {
      return;
    }

    if (record) {
      form.setFieldsValue(record);
      return;
    }

    form.resetFields();
  }, [form, open, record]);

  const handleOk = async () => {
    setConfirmLoading(true);
    const values = await form
      .validateFields()
      .then(res => res)
      .catch(() => null);
    setConfirmLoading(false);

    if (!values) {
      return;
    }

    onOk({
      id: record?.id ?? Date.now(),
      backendId: record?.backendId,
      relatedDevices: record?.relatedDevices ?? [],
      relatedDeviceIds: record?.relatedDeviceIds ?? [],
      ...values,
    });
  };

  return (
    <Modal
      title={record ? '编辑辅助用能' : '新增辅助用能'}
      open={open}
      width={520}
      contentClassName="modal-form-content"
      destroyOnClose
      confirmLoading={confirmLoading}
      onCancel={onCancel}
      onOk={handleOk}
    >
      <Form form={form} layout="horizontal" labelCol={{ span: 7 }} wrapperCol={{ span: 17 }}>
        <Form.Item
          label="辅助用能名称"
          name="name"
          rules={[
            { required: true, whitespace: true, message: '请输入' },
            { min: 1, max: 50, message: '请输入1~50个字符' },
            { validator: validateUniqueName },
          ]}
        >
          <Input placeholder="请输入" maxLength={50} />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default EditAuxiliaryDeviceModal;
